import { twMerge } from "tailwind-merge";

interface Props {
  className?: Partial<{
    wrapper: string;
    bullet: string;
  }>
}

export default function SectionDivider({ className }: Props) {
  return (
    <div className={twMerge(`select-none h-[12px] w-full relative mb-[20px]`, className?.wrapper)}>
      <div className="w-full h-[4px] absolute top-[50%] left-0 translate-y-[-50%] bg-secondary-400" />
      <div className={twMerge('absolute rounded-full top-0 desktop:left-0 rtl:desktop:right-0 left-[50%] translate-x-[-50%] tablet:w-[30%] desktop:translate-x-0 bg-secondary-300 h-full w-[70%]', className?.bullet)} />
    </div>
  )
} 